<template>
    <div class="vx-card p-6 ">
        <vs-tabs>
            <vs-tab label="Email Settings">
                <Email></Email>
            </vs-tab>
            <vs-tab label="Template Catogary">
                <Catogary></Catogary>
            </vs-tab>
            <vs-tab label="Template">
                <Template></Template>
            </vs-tab>
        </vs-tabs>
    </div>
</template>
<script>

import Email from "./Email.vue"
import Template from "./Template.vue"
import Catogary from "./Catogary.vue"


export default {
    components: {
        Email,
        Template,
        Catogary
    },}
</script>
